export default "__VITE_ASSET__DYI1LpnD__"